import { BasicMedicationEntry } from "pokal_api"

function medIsCoMed(entry: BasicMedicationEntry) {
    return !entry.atc.startsWith("N06A") && !entry.atc.startsWith("G04BX18") && !entry.atc.startsWith("D04AX01") && !entry.atc.startsWith("N07BA02") && !entry.atc.startsWith("A08AA62") && !entry.atc.startsWith("N06CA")
}

export interface SplitMeds {
    co: BasicMedicationEntry[],
    antidepressants: BasicMedicationEntry[]
}

export function splitBasicMedicationEntries(entries: BasicMedicationEntry[]): SplitMeds {
    return {
        co: entries.filter(e => medIsCoMed(e)),
        antidepressants: entries.filter(e => !medIsCoMed(e))
    }
}
export default medIsCoMed